import React, { useState } from "react"
import { Flex, Popover } from "antd"
import { useTranslation } from "react-i18next"
import { Icon } from "ui/Icon"
import { BOOKING_PAYMENT_STATES, DAY_STATUS_STATES } from "../../constants"
import styles from "./index.module.css"

/**
 * "Legend ⓘ" in the calendar header, and the card it opens: what the colour down the left of a
 * booking tile means, and what the shading of a whole day means.
 *
 * Both lists are read from the same constants the calendar itself colours with, so a swatch
 * cannot drift from what it describes.
 */
const LegendPopover = () => {
  const { t } = useTranslation()
  const [isOpen, setIsOpen] = useState(false)

  const renderSection = (titleKey, titleDefault, states) => (
    <Flex vertical gap="var(--spacing-xxs)">
      <span className={styles.sectionTitle}>{t(titleKey, { defaultValue: titleDefault })}</span>
      <Flex align="center" gap="var(--spacing-m)" wrap>
        {states.map((state) => (
          <Flex key={state.key} align="center" gap="var(--spacing-xxs)">
            <span
              aria-hidden
              className={`${styles.swatch} ${state.color ? "" : styles.swatchEmpty}`}
              style={state.color ? { background: state.color } : undefined}
            />
            <span className={styles.swatchLabel}>{t(state.labelKey, { defaultValue: state.labelDefault })}</span>
          </Flex>
        ))}
      </Flex>
    </Flex>
  )

  const content = (
    <Flex vertical gap="var(--spacing-s)" className={styles.card}>
      <Flex align="center" gap="var(--spacing-s)">
        <span className={styles.title}>{t("calendar.legend.title", { defaultValue: "Legend" })}</span>
        <button
          type="button"
          className={styles.close}
          onClick={() => setIsOpen(false)}
          aria-label={t("common.close", { defaultValue: "Close" })}
        >
          <Icon name="X" width={24} height={24} color="var(--color-text-primary)" />
        </button>
      </Flex>

      <Flex vertical gap="var(--spacing-s)">
        {renderSection("calendar.legend.bookings", "Bookings:", BOOKING_PAYMENT_STATES)}
        {renderSection("calendar.legend.day_status", "Day Status:", DAY_STATUS_STATES)}
      </Flex>
    </Flex>
  )

  return (
    <Popover
      open={isOpen}
      onOpenChange={setIsOpen}
      trigger={["click"]}
      placement="bottomRight"
      arrow={false}
      content={content}
      overlayClassName={styles.overlay}
    >
      <button type="button" className={styles.trigger}>
        <span>{t("calendar.legend.title", { defaultValue: "Legend" })}</span>
        <Icon name="Info" width={20} height={20} color="var(--color-primary)" />
      </button>
    </Popover>
  )
}

export default LegendPopover
